import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtDateTime } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function SdAudit() {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [d, setD] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/servicedesk/audit", { params: { q, page } }).then(({ data }) => setD(data)).catch((e) => setD({ error: e.response?.data?.detail || "Not allowed", rows: [] })), 250);
    return () => clearTimeout(t);
  }, [q, page]);
  return (
    <div data-testid="sd-audit-page">
      <PageHeader title="Audit Trail" subtitle="Read-only record of every ticket action, assignment, approval and SLA event" />
      <Input value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="Search by person or note" className="mb-3 max-w-md" data-testid="sd-audit-search" />
      {d?.error && <p className="text-sm text-red-600" data-testid="sd-audit-error">{d.error}</p>}
      <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto">
        <table className="w-full text-xs" data-testid="sd-audit-table">
          <thead className="bg-slate-50 text-slate-500"><tr><th className="text-left p-2">When</th><th className="text-left p-2">Ticket</th><th className="text-left p-2">Action</th><th className="text-left p-2">By</th><th className="text-left p-2">Details</th></tr></thead>
          <tbody>{(d?.rows || []).map((r, i) => (
            <tr key={`${r.at}-${i}`} className="border-t border-slate-100 align-top">
              <td className="p-2 whitespace-nowrap">{fmtDateTime(r.at)}</td>
              <td className="p-2"><Link to={`/servicedesk/tickets/${r.ticket_id}`} className="text-sky-700 hover:underline font-mono">{r.number}</Link></td>
              <td className="p-2 font-medium">{r.action}{r.to_status ? ` → ${r.to_status}` : ""}{r.to_priority ? ` (${r.from_priority} → ${r.to_priority})` : ""}</td>
              <td className="p-2">{r.by}</td><td className="p-2 text-slate-600">{r.note}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      {d && d.pages > 1 && <div className="flex justify-end gap-2 mt-3"><Button size="sm" variant="outline" disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</Button><Button size="sm" variant="outline" disabled={page >= d.pages} onClick={() => setPage(page + 1)}>Next</Button></div>}
    </div>
  );
}
